module.exports = __webpack_public_path__ + "static/media/email-icon.dc73c6bf.svg";